import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import DesktopRoutes from './routes/DesktopRoutes';
import MobileRoutes from './routes/MobileRoutes';
import { isMobile, isBrowser, isSmartTV } from "react-device-detect"
import i18n from './i18n';

import './styles/design-system.css';
import './App.css';

// Keeps the <html lang="..."> attribute in sync with the active i18next
// language so crawlers and assistive tech get an accurate language signal.
function useHtmlLangSync() {
    useEffect(() => {
        const applyLang = (lng) => {
            document.documentElement.lang = lng || 'en';
        };
        applyLang(i18n.language);
        i18n.on('languageChanged', applyLang);
        return () => i18n.off('languageChanged', applyLang);
    }, []);
}

export const App = () => {
    useHtmlLangSync();

    return (
        <HelmetProvider>
            {isMobile && <MobileRoutes />}
            {(isBrowser || isSmartTV) && <DesktopRoutes />}
        </HelmetProvider>
    )
}

export default App;